import { z } from "zod/v4";
export const santeclairFeeLimitItemSchema = z.object({
    actKey: z.string().min(1),
    actLabel: z.string().min(1),
    ccamCode: z.string().min(1),
    practitionerMaxFeeCents: z.number().int().nonnegative(),
});
export const santeclairFeeLimitsSchema = z.array(santeclairFeeLimitItemSchema);
export const santeclairFeeLimitValuesSchema = z.record(z.string(), z.number().int().nonnegative());
//# sourceMappingURL=SanteclairFeeLimits.js.map